import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemText,
  ListItemTextProps,
  SxProps,
  Theme,
  useMediaQuery,
} from "@mui/material";
import React, { ReactNode } from "react";
import { Link, To } from "react-router";
import { sxEnsureArray } from "../../Helpers/sxMerge";

export interface BNListItemProps extends ListItemButtonProps {
  icon?: React.ReactElement;
  to?: To;
  textSx?: SxProps<Theme>;
  secondaryTextSx?: SxProps<Theme>;
  target?: string;
  color?: ListItemButtonProps["color"];
  showArrowForward?: boolean;
  isSpa?: (path: string) => boolean;
  state?: any;
  overrideLinkIcon?: ReactNode;
  secondaryText?: ListItemTextProps["secondary"];
  left?: ReactNode;
  overrideIconMinWidth?: string;
}

const BNListItem: React.FC<BNListItemProps> = (props) => {
  const isTouch = useMediaQuery("(pointer: coarse)");
  const {
    isSpa,
    state,
    overrideLinkIcon,
    target,
    color,
    sx,
    children,
    secondaryText,
    showArrowForward,
    to: toProp,
    textSx,
    secondaryTextSx,
    icon,
    left,
    overrideIconMinWidth,
    ...restOfProps
  } = props;

  const sxInputArray = sxEnsureArray(sx);
  const backgroundColorFromSx = sxInputArray[0]?.backgroundColor;

  const modifixedSx: SxProps<Theme> = [
    {
      backgroundColor: color || "background.paper",
      borderRadius: "0.8rem",
      py: 2,
    },
    // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
    ...sxInputArray,
    isTouch
      ? {
          ":hover": {
            backgroundColor: backgroundColorFromSx || color || "background.paper",
          },
        }
      : undefined,
  ];

  const modifixedTextSx: SxProps<Theme> = [
    {
      fontWeight: typeof children === "string" ? "bold" : "inherit",
      fontSize: { xs: "1.3rem", md: "1.6rem" },
    },
    // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
    ...(Array.isArray(textSx) ? textSx : [textSx]),
  ];
  const to = toProp?.toString();
  const doSpaNav = isSpa && to && isSpa(to);

  const navProps = !to
    ? {}
    : doSpaNav
      ? {
          LinkComponent: Link,
          to: doSpaNav ? to : undefined,
          state,
          target,
        }
      : {
          LinkComponent: "a" as ListItemButtonProps["LinkComponent"],
          href: to,
          target,
        };
  return (
    <ListItemButton sx={modifixedSx} focusRipple={!isTouch} {...navProps} {...restOfProps}>
      {left}
      {icon ? (
        <ListItemIcon
          sx={[
            {
              minWidth: overrideIconMinWidth ?? "4rem",
              color: "inherit",
            },
          ]}
        >
          {icon}
        </ListItemIcon>
      ) : null}
      <ListItemText
        primary={children}
        secondary={secondaryText}
        slotProps={{
          primary: { sx: modifixedTextSx },
          secondary: { sx: secondaryTextSx },
        }}
      />
      {!overrideLinkIcon && (to != null || showArrowForward) && showArrowForward !== false && (
        <ArrowForwardIosIcon sx={{ fontSize: "medium", ml: 1 }} />
      )}
      {overrideLinkIcon}
    </ListItemButton>
  );
};

export default BNListItem;
